<template>
  <div id="app">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "App",
};
</script>

<style>
.search-box {
  padding: 0px 20px 0 20px;
}
.el-menu-item i {
  color: #ffffff !important;
}

.reback {
  position: absolute;
  right: 20px;
  top: 78px;
  z-index: 9999;
}
</style>
